import React, { useEffect, useState } from 'react'
import { getLocalizedValue } from './PageDetail'
import { useSEO } from '../lib/useSEO'

export function resizeImage(url, width = 300, height = 300) {
  if (url && url.includes('assets.auxodev.dk')) {
    // Check if it already has cdn-cgi
    if (url.includes('/cdn-cgi/image/')) return url
    return url.replace('assets.auxodev.dk/assets/', `assets.auxodev.dk/cdn-cgi/image/width=${width},height=${height},fit=cover,format=auto/assets/`)
  }
  return url
}

export default function Medarbejdere() {
  const [page, setPage] = useState(null)
  const [medarbejdere, setMedarbejdere] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    Promise.all([
      fetch('https://api.dev.auxo.dk/public/by-slug/da/medarbejdere').then(res => res.json()),
      fetch('https://api.dev.auxo.dk/public/content/medarbejdere').then(res => res.json())
    ])
      .then(([pageData, listData]) => {
        setPage(pageData)
        setMedarbejdere(listData)
        setLoading(false)
      })
      .catch((err) => {
        console.error(err)
        setLoading(false)
      })
  }, [])

  useSEO({
    title: page ? getLocalizedValue(page.title) : 'Medarbejdere · Vikar4',
    description: page ? (getLocalizedValue(page.meta_description) || getLocalizedValue(page.og_description) || 'Mød teamet bag Vikar4 – dedikerede medarbejdere med stor erfaring inden for vikarløsninger og rekruttering.') : 'Mød teamet bag Vikar4 – dedikerede medarbejdere med stor erfaring inden for vikarløsninger og rekruttering.',
    ogTitle: page ? getLocalizedValue(page.og_title) : 'Medarbejdere · Vikar4',
    ogDescription: page ? (getLocalizedValue(page.og_description) || getLocalizedValue(page.meta_description)) : '',
    canonicalPath: '/medarbejdere'
  })

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600" />
      </div>
    )
  }

  return (
    <div className="bg-white">
      {/* Page Header - Hero Banner Component */}
      <section className="relative h-[240px] md:h-[320px] bg-[#015D9A] flex items-center justify-center overflow-hidden">
        {/* Background Image with Cool-toned Dark Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center mix-blend-multiply opacity-60 bg-[url('https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/7b6c8b8c-dd85-4faa-a1de-b9b48f1b2725/industrial-subpage-hero.jpg')]"
        />
        {/* Centered Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-wide">
            {getLocalizedValue(page?.title) || 'Medarbejdere'}
          </h1>
        </div>
      </section>

      {/* Main Content - Full Width Layout */}
      <main className="max-w-7xl mx-auto px-6 py-16 lg:py-24">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
            {medarbejdere.map((person) => {
              const imageUrl = person.image && person.image[0] ? person.image[0] : ''
              const optimizedImage = resizeImage(imageUrl, 400, 400)

              return (
                <div
                  key={person.id}
                  className="flex flex-col items-center text-center md:items-start md:text-left bg-white rounded-sm border border-slate-100 p-8 shadow-none hover:border-[#015D9A] transition-all"
                >
                  <div className="relative mb-6 h-40 w-40 overflow-hidden rounded-sm border border-slate-100">
                    <img
                      src={optimizedImage}
                      alt={`Portrætfoto af ${getLocalizedValue(person.name)}, ${getLocalizedValue(person.title)} hos Vikar4`}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <h2 className="text-2xl font-bold text-[#0f3d5c]">
                    {getLocalizedValue(person.name)}
                  </h2>
                  <p className="text-sm font-semibold text-[#015D9A] mt-1 uppercase tracking-wider">
                    {getLocalizedValue(person.title)}
                  </p>
                  <div
                    className="prose-custom text-sm mt-4"
                    dangerouslySetInnerHTML={{ __html: getLocalizedValue(person.description) }}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </main>
    </div>
  )
}
